import ContextModel from '../context/index.model.js';
import WidgetModel from '../widget/index.model.js';
export default {
    context: { type: 'model', model: ContextModel },
    rfk_flags: { type: 'array', name: 'rfkFlags' },
    widget: { type: 'model', model: WidgetModel },
};
